module.exports = __webpack_public_path__ + "img/KarimKaka.0afb51ca.jpg";